export const fontSizes = {
  p: 17,
  h1: 32,
  h2: 24,
  h3: 20,
}
